import { render } from "./NotaFiscalServicoIndex.vue?vue&type=template&id=e0099ca6&scoped=true&ts=true"
import script from "./NotaFiscalServicoIndex.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalServicoIndex.vue?vue&type=script&lang=ts"

import "./NotaFiscalServicoIndex.vue?vue&type=style&index=0&id=e0099ca6&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0099ca6"]])

export default __exports__